















































































import { defineComponent, reactive, watch } from "@vue/composition-api";
import Loading from "@/components/Loading.vue";
import WysiwygEditor from "@/components/WysiwygEditor.vue";
import { Button } from "@micad/vue-components";
import ImageUploadWidget from "@/components/ImageUploadWidget.vue";
import { Branding, getBranding, updateBranding } from "@/data/repos/branding";
import Vue from "vue";
import { displayRequestStatus } from "@/notifications";
import { App } from "@/interfaces/common.interfaces";
import { getApps } from "@/data/repos/apps";
import { canIUse } from "@/modules/auth";

export default defineComponent({
  methods: { canIUse },
  components: {
    ImageUploadWidget,
    Loading,
    WysiwygEditor,
    Button,
  },
  setup() {
    const state = reactive({
      WysiwygEditor: "",
      loaded: true,
      brandingApps: [] as App[],
      branding: {
        images: [],
        text: "",
        kind: "login",
        app: "",
      } as Branding,
      removeImage,
      saveBranding,
    });
    function removeImage(i: number) {
      Vue.set(state.branding.images, i, "");
    }
    async function retrieveBranding(app: string | undefined) {
      state.loaded = false;
      const branding = (await getBranding(app || undefined, "login")).payload;
      state.branding.text = branding?.text || "";
      state.WysiwygEditor = branding?.text || "";
      state.loaded = true;
      state.branding.images.splice(0, state.branding.images.length);
      for (let i = (branding?.images || []).length; i < 3; i++) {
        Vue.set(state.branding.images, i, "");
      }
      (branding?.images || []).forEach((e, i) =>
        Vue.set(state.branding.images, i, e)
      );
    }
    async function saveBranding() {
      const images: string[] = [];
      state.branding.images.forEach((i) => i && images.push(i));

      const resp = await updateBranding({
        ...state.branding,
        images,
        app: state.branding.app || undefined,
      });
      displayRequestStatus(resp, "Saved", "Failed to save branding");
      if (resp.ok) {
        await retrieveBranding(state.branding.app);
      }
    }
    watch(
      () => state.branding.app,
      (v) => retrieveBranding(v)
    );
    setTimeout(async () => {
      state.brandingApps = [
        { id: "", title: "All modules" },
        ...((await getApps()).payload || []),
      ];
      await retrieveBranding(state.branding.app);
    }, 0);
    return state;
  },
});
